import * as constants from "./../constants";
import * as logger from './../../logger';

const defaultState = {
  tripEditArrowFlags: {
    profitSumRevenue: true,
    profitSumExpense: true,
    partyAdvance: true,
    partyDeduction: true,
    partyCharges: true,
    partyPayments: true,
    vendorAdvance: true,
    vendorDeduction: true,
    vendorCharges: true,
    vendorPayments: true
  },
  tripModalFlags: {
    deductionModalOpen: false,
    deductionDeleteOpen: false,
    paymentModalOpen: false,
    paymentDeleteOpen: false,
    expenseModalOpen: false,
    expenseDeleteOpen: false,
    advanceModalOpen: false,
    advanceDeleteOpen: false,
    vendorDeductionModalOpen: false,
    vendorDeductionDeleteOpen: false,
    vendorPaymentModalOpen: false,
    vendorPaymentDeleteOpen: false,
    vendorExpenseModalOpen: false,
    vendorExpenseDeleteOpen: false,
    vendorAdvanceModalOpen: false,
    vendorAdvanceDeleteOpen: false,
    vendorTruckHireCostOpen: false,
    vendorTruckHireCostDeleteOpen: false,
    tripCreateDeductionModalOpen: false,
    tripCreateDeductionDeleteOpen: false,
    tripCreateExpenseModalOpen: false,
    tripCreateExpenseDeleteOpen: false,
    tripCreateAdvanceModalOpen: false,
    tripCreateAdvanceDeleteOpen: false,
    tripCreateVendorDeductionModalOpen: false,
    tripCreateVendorDeductionDeleteOpen: false,
    tripCreateVendorExpenseModalOpen: false,
    tripCreateVendorExpenseDeleteOpen: false,
    tripCreateVendorAdvanceModalOpen: false,
    tripCreateVendorAdvanceDeleteOpen: false,
    tripCreateVendorTruckHireCostOpen: false
  },
  currentPartyDeduction: { id: null, displayName: '', amount: 0, description: '' },
  currentPartyAdvance: { id: null, displayName: '', amount: 0, paymentMode: 'Cash', description: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) },
  currentPartyPayment: { id: null, displayName: '', amount: 0, paymentMode: 'Cash', description: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) },
  currentPartyExpense: { id: null, displayName: '', amount: 0, description: '', isBillable: false, billableAmount: 0 },
  currentVendorDeduction: { id: null, displayName: '', amount: 0, description: '' },
  currentVendorAdvance: { id: null, displayName: '', amount: 0, paymentMode: 'Cash', description: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) },
  currentVendorPayment: { id: null, displayName: '', amount: 0, paymentMode: 'Cash', description: '', paymentData: '', paymentDate: Math.round(new Date().getTime() / 1000) },
  currentVendorExpense: { id: null, type: '', displayName: '', amount: 0, description: '', isBillable: false, billableAmount: 0 },
  currentTruckHireCostExpense: { id: null, displayName: '', amount: 0, description: '', isBillable: false },

  createTripOriginLocations: [],
  createTripDestinationLocations: [],
  createTripParties: [],
  createTripVehicles:[],
  createTripSuppliers:[],
  createTripDrivers:[],
  currentCreateTripAdvanceIndex: null,
  currentCreateTripDeductionIndex: null,
  currentCreateTripExpenseIndex: null,
  currentCreateTripVendorAdvanceIndex: null,
  currentCreateTripVendorDeductionIndex: null,
  currentCreateTripVendorExpenseIndex: null,
  createTripAdvances: [],
  createTripDeductions: [],
  createTripExpenses: [],
  createTripVendorAdvances: [],
  createTripVendorDeductions: [],
  createTripVendorExpenses: [],
  createTripData: {
    activeTruck: {},
    activeDestination: "",
    activeOrigin: "",
    balancePending: 0,
    truckHireCost: 0,
    activeFreightAmount: 0
  },
  createdTrip: { id: null },

  addPartyFlag: false,
  currentUploadedPods: [],
  tripExpenseTypes: [],
  tripPdfData: {},
  elrLoadData: {},
  elrGstInfo: {},
  consigneeList: [],
  consignorList: [],
  singleConsignee: {},
  singleConsignor: {},
  materialList: [],
  elrInfo: {},
  insuranceProvidersList: [],
  biltyDataPopulated: false,
  biltyContinueClick: false,
  congineePdf: {},
  consignorPdf: {},
  tripChargeType: [],
  tripDeductionType: [],
  truckIncomeReport: {},
  invoiceLedgerData: {

  },
  invoiceTrips: {},
  invoiceCustomers: {},
  singleInvoiceInfo: {},
  singleInvoicePdf: {},
  editInvoiceFlag: false,
};

export default function tripReducer(state = defaultState, action) {
  switch (action.type) {
    case constants.UPDATE_TRIP_EDIT_ARROW_FLAGS:
      let tripEditArrowFlags = { ...state.tripEditArrowFlags, ...action.payload };
      return { ...state, tripEditArrowFlags };
    case constants.UPDATE_TRIP_EDIT_MODAL_FLAGS:
      let tripModalFlags = { ...state.tripModalFlags, ...action.payload };
      return { ...state, tripModalFlags };
    case constants.TRIP_EXPENSE_TYPES:
      return { ...state, ...{ tripExpenseTypes: action.payload } }
    case constants.UPDATE_CURRENT_PARTY_DEDUCTION:
      state.currentPartyDeduction = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentPartyDeduction))
      return state;
    case constants.UPDATE_CURRENT_PARTY_EXPENSE:
      state.currentPartyExpense = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentPartyExpense))
      return state;
    case constants.UPDATE_CURRENT_PARTY_ADVANCE:
      state.currentPartyAdvance = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentPartyAdvance))
      return state;
    case constants.UPDATE_CURRENT_PARTY_PAYMENT:
      state.currentPartyPayment = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentPartyPayment))
      return state;
    case constants.UPDATE_CURRENT_VENDOR_DEDUCTION:
      state.currentVendorDeduction = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentVendorDeduction))
      return state;
    case constants.UPDATE_CURRENT_VENDOR_EXPENSE:
      state.currentVendorExpense = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentVendorExpense))
      return state;
    case constants.UPDATE_CURRENT_VENDOR_ADVANCE:
      state.currentVendorAdvance = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentVendorAdvance))
      return state;
    case constants.UPDATE_CURRENT_VENDOR_PAYMENT:
      state.currentVendorPayment = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentVendorPayment))
      return state;
    case constants.UPDATE_CURRENT_TRUCK_HIRE_COST_EXPENSE:
      state.currentTruckHireCostExpense = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state))
      return state;
    case constants.GET_CREATE_TRIP_ORIGIN_LOCATIONS:
      state.createTripOriginLocations = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state))
      return state;
    case constants.GET_CREATE_TRIP_DEST_LOCATIONS:
      state.createTripDestinationLocations = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state))
      return state;
    case constants.ADD_CUSTOM_LOCATION:
      if (action.payload.locationType === 'O') {
        state.createTripOriginLocations.push({ name: action.payload.name });
      } else {
        state.createTripDestinationLocations.push({ name: action.payload.name });
      }
      return state;
    case constants.GET_PARTY_LIST:
      if (action.payload.merge) {
        state.createTripParties = {
          ...action.payload.payloadData,
          parties:[
            ...state.createTripParties.parties,
            ...action.payload.payloadData.parties
          ]
        }
      } else {
        state.createTripParties = action.payload.payloadData
      }
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripParties))
      return state;
    case constants.GET_VEHICLE_LIST:
        if (action.payload.merge) {
          state.createTripVehicles = {
            ...action.payload.payloadData,
            trucks:[
              ...state.createTripVehicles.trucks,
              ...action.payload.payloadData.trucks
            ]
          }
        } else {
          state.createTripVehicles = action.payload.payloadData
        }
        return state;
    case constants.GET_SUPPLIER_LIST:
        if (action.payload.merge) {
          state.createTripSuppliers = {
            ...action.payload.payloadData,
            suppliers:[
              ...state.createTripSuppliers.suppliers,
              ...action.payload.payloadData.suppliers
            ]
          }
        } else {
          state.createTripSuppliers = action.payload.payloadData
        }
        return state;
      case constants.GET_DRIVER_LIST:
        if (action.payload.merge) {
          state.createTripDrivers = {
            ...action.payload.payloadData,
            drivers:[
              ...state.createTripDrivers.drivers,
              ...action.payload.payloadData.drivers
            ]
          }
        } else {
          state.createTripDrivers = action.payload.payloadData
        }
        return state;
    case constants.UPDATE_CREATE_TRIP_RESPONSE:
      state.createdTrip = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createdTrip))
      return state;
    case constants.UPDATE_CREATE_TRIP_PARTY_ADVANCE:
      state.createTripAdvances = action.payload;
      var createTripData = refreshCreateTripScreenData(state, null);
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripAdvances))
      return { ...state, ...{ createTripData: createTripData } };
    case constants.UPDATE_CREATE_TRIP_PARTY_DEDUCTION:
      state.createTripDeductions = action.payload
      var createTripData = refreshCreateTripScreenData(state, null);
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripDeductions))
      return { ...state, ...{ createTripData: createTripData } };
    case constants.UPDATE_CREATE_TRIP_PARTY_EXPENSE:
      state.createTripExpenses = action.payload
      var createTripData = refreshCreateTripScreenData(state, null);
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripExpenses))
      return { ...state, ...{ createTripData: createTripData } };
    case constants.UPDATE_CREATE_TRIP_VENDOR_ADVANCE:
      state.createTripVendorAdvances = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripVendorAdvances))
      return { ...state, ...{ createTripVendorAdvances: action.payload } };
    case constants.UPDATE_CREATE_TRIP_VENDOR_DEDUCTION:
      state.createTripVendorDeductions = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripVendorDeductions))
      return { ...state, ...{ createTripVendorDeductions: action.payload } };
    case constants.UPDATE_CREATE_TRIP_VENDOR_EXPENSE:
      state.createTripVendorExpenses = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.createTripVendorExpenses))
      return { ...state, ...{ createTripVendorExpenses: action.payload } };
    case constants.UPDATE_CREATE_TRIP_PARTY_ADVANCE_INDEX:
      state.currentCreateTripAdvanceIndex = action.payload;
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentCreateTripAdvanceIndex))
      return state;
    case constants.UPDATE_CREATE_TRIP_PARTY_DEDUCTION_INDEX:
      state.currentCreateTripDeductionIndex = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentCreateTripDeductionIndex))
      return state;
    case constants.UPDATE_CREATE_TRIP_PARTY_EXPENSE_INDEX:
      state.currentCreateTripExpenseIndex = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentCreateTripExpenseIndex))
      return state;
    case constants.UPDATE_CREATE_TRIP_VENDOR_ADVANCE_INDEX:
      state.currentCreateTripVendorAdvanceIndex = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentCreateTripVendorAdvanceIndex))
      return state;
    case constants.UPDATE_CREATE_TRIP_VENDOR_DEDUCTION_INDEX:
      state.currentCreateTripVendorDeductionIndex = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentCreateTripVendorDeductionIndex))
      return state;
    case constants.UPDATE_CREATE_TRIP_VENDOR_EXPENSE_INDEX:
      state.currentCreateTripVendorExpenseIndex = action.payload
      logger.log("TripReducer", "------> TRIP REDUCER : " + JSON.stringify(state.currentCreateTripVendorExpenseIndex))
      return state;
    case constants.UPDATE_CREATE_TRIP_DATA:
      state.createTripData = refreshCreateTripScreenData(state, { ...state.createTripData, ...action.payload });
      logger.log("TripReducer", "------> TRIP REDUCER :: createTripData :: " + JSON.stringify(state.createTripData))
      return state;
    case constants.UPDATE_ADD_PARTY_FLAG:
      logger.log("TripReducer", "------> TRIP REDUCER :: updateAddPartyFlag :: ")
      return { ...state, ...{ addPartyFlag: !state.addPartyFlag, searchText: action.payload } };
    case constants.ADD_PARTY:
      return { ...state, ...{ addedParty: action.payload } }
    case constants.ADD_SHOP:
      return { ...state, ...{ addedShop: action.payload } }
    case constants.DELETE_CREATE_TRIP_TRANSACTIONS:
      state.createTripAdvances = [];
      state.createTripDeductions = [];
      state.createTripExpenses = [];
      state.createTripVendorAdvances = [];
      state.createTripVendorDeductions = [];
      state.createTripVendorExpenses = [];
      if (state.createTripData) {
        state.createTripData.truckHireCost = 0;
      }
      logger.log("TripReducer", "------> TRIP REDUCER :: createTripTransactions :: CLEARED");
      return state;
    case constants.DELETE_CREATE_TRIP_TRUCK_HIRE_COST:
      if (state.createTripData) {
        state.createTripData.truckHireCost = 0;
        state.createTripVendorAdvances = [];
        state.createTripVendorDeductions = [];
        state.createTripVendorExpenses = [];
      }
      logger.log("TripReducer", "------> TRIP REDUCER :: create-trip truckHireCost :: CLEARED");
      return state;
    case constants.ADD_TRIP_POD_CTA:
      return { ...state, ...{ currentUploadedPods: action.payload } };
    case constants.GET_TRIP_PDF:
      return { ...state, ...{ tripPdfData: action.payload } };
    case constants.LOAD_ELR:
      return { ...state, ...{ elrLoadData: action.payload } };
    case constants.ELR_GST_INFO:
      return { ...state, ...{ elrGstInfo: action.payload } };
    case constants.GET_CONSIGNEE_LIST:
      return { ...state, ...{ consigneeList: action.payload } };
    case constants.GET_CONSIGNOR_LIST:
      return { ...state, ...{ consignorList: action.payload } };
    case constants.ADD_CONSIGNEE:
      return { ...state, ...{ singleConsignee: action.payload } };
    case constants.ADD_CONSIGNOR:
      return { ...state, ...{ singleConsignor: action.payload } };
    case constants.MATERIAL_LIST:
      return { ...state, ...{ materialList: action.payload } };
    case constants.ELR_INFO:
      return { ...state, ...{ elrInfo: action.payload } };
    case constants.GET_INSURANCE_PROVIDERS:
      return { ...state, ...{ insuranceProvidersList: action.payload } };
    case constants.BILTY_DATA_POPULATED:
      return { ...state, ...{ biltyDataPopulated: action.payload } }
    case constants.BILTY_CONTINUE_CLICK:
      return { ...state, ...{ biltyContinueClick: action.payload } };
    case constants.GET_CONSIGNEE_PDF:
      return { ...state, ...{ congineePdf: action.payload } };
    case constants.GET_CONSIGNOR_PDF:
      return { ...state, ...{ consignorPdf: action.payload } };
    case constants.TRIP_CHARGE_TYPES:
      return { ...state, ...{ tripChargeType: action.payload } };
    case constants.TRIP_DEDUCTION_TYPES:
      return { ...state, ...{ tripDeductionType: action.payload } };
    case constants.TRUCK_INCOME_REPORT:
      return { ...state, ...{ truckIncomeReport: action.payload } };
    case constants.GET_TRIP_DEFAULTS:
      return { ...state, ...{ tripDefaults: action.payload } };
    case constants.GET_INVOICES_LIST:

      if (action.payload.merge) {

        state.invoiceLedgerData.currentPageNo = action.payload && action.payload.invoiceData && action.payload.invoiceData.currentPageNo ? action.payload.invoiceData.currentPageNo : 0;
        state.invoiceLedgerData.currentPageSize = action.payload && action.payload.invoiceData && action.payload.invoiceData.currentPageSize ? action.payload.invoiceData.currentPageSize : 0;
        state.invoiceLedgerData.maxPage = action.payload && action.payload.invoiceData && action.payload.invoiceData.maxPage ? action.payload.invoiceData.maxPage : 0;
        state.invoiceLedgerData.paidInvoiceCount = action.payload && action.payload.invoiceData && action.payload.invoiceData.paidInvoiceCount ? action.payload.invoiceData.paidInvoiceCount : 0;
        state.invoiceLedgerData.totalCount = action.payload && action.payload.invoiceData && action.payload.invoiceData.totalCount ? action.payload.invoiceData.totalCount : 0;
        state.invoiceLedgerData.totalInvoiceCount = action.payload && action.payload.invoiceData && action.payload.invoiceData.totalInvoiceCount ? action.payload.invoiceData.totalInvoiceCount : 0;
        state.invoiceLedgerData.unpaidInvoiceCount = action.payload && action.payload.invoiceData && action.payload.invoiceData.unpaidInvoiceCount ? action.payload.invoiceData.unpaidInvoiceCount : 0;

        state.invoiceLedgerData.invoices = [
          ...state.invoiceLedgerData.invoices,
          ...action.payload.invoiceData.invoices
        ]


      } else {
        
        return { ...state, ...{ invoiceLedgerData: action.payload.invoiceData } }
      }


    // return { ...state, ...{ invoiceLedgerData: action.payload } };
    case constants.GET_INVOICES_TRIPS:
      return { ...state, ...{ invoiceTrips: action.payload } };
    case constants.GET_INVOICE_CUSTOMERS:
      return { ...state, ...{ invoiceCustomers: action.payload } }
    case constants.GET_SINGLE_INVOICE:
      return { ...state, ...{ singleInvoiceInfo: action.payload } }
    case constants.TOGGLE_EDIT_INVOICE_FLAG:
      return { ...state, ...{ editInvoiceFlag: action.payload } }
    case constants.GET_SINGLE_INVOICE_PDF:
      return { ...state, ...{ singleInvoicePdf: action.payload } }
    default:
      return state
  }
}

const refreshCreateTripScreenData = (currentState, createTripData) => {
  var balancePending = 0.0;
  var totalAdvances = 0.0, totalExpenses = 0.0, totalDeductions = 0.0;
  currentState.createTripAdvances.map((advance) => { totalAdvances += parseFloat(advance.amount) })
  currentState.createTripDeductions.map((deduction) => { totalDeductions += parseFloat(deduction.amount) })
  currentState.createTripExpenses.map((expense) => { totalExpenses += parseFloat(expense.amount) })

  if (null == createTripData)
    createTripData = currentState.createTripData
  balancePending = (parseFloat(createTripData.activeFreightAmount) + parseFloat(totalExpenses)) - (parseFloat(totalAdvances) + parseFloat(totalDeductions));

  logger.log("TripReducer", "----> BALANCE PENDING : " + balancePending + " :: " + createTripData.activeFreightAmount);
  logger.log("TripReducer", "--> EXP : " + totalExpenses + " ---> DED : " + totalDeductions + " ---> ADV : " + totalAdvances);
  return { ...createTripData, ...{ balancePending: balancePending } };
}
